/* Gatlinburg-only sidecar — loaded AFTER assets/awtomic-theme-custom.js (the
   shared Build-a-Box kit) by snippets/awtomic-theme-custom.liquid.
   Holds the four behaviours that are specific to this shop: the club price
   minimums (CX-5076), the required-wine gate (CX-5059) and the customer-portal
   pickup block (CX-5077).

   🔴 THE WHOLE FILE IS INSIDE ONE FUNCTION ON PURPOSE. Both this file and the
   kit declare `waitForElement` and `babMinimums` at the top level. Two ordinary
   <script> files share one global scope, so a second `const` with the same name
   is a SyntaxError and the ENTIRE second file then never runs — either the kit
   layout or all three gates above would disappear with no visible error other
   than a console message. The wrapper keeps every name in here private.
   Do not remove it, and do not un-indent. */
(function () {

/* ==================================================================== */
/* ===== SHOP CONFIG — EDIT THIS ====================================== */
/* ==================================================================== */

/* Per-club minimum box price, enforced on the Build-a-Box purchase flow and
   on the customer-portal box editor. The bottle minimum is the bundle's own
   box-size setting; this adds the dollar minimum on top of it.
   Keyed: Build-a-Box product id -> Build-a-Box variant id -> minimum price. */
const babMinimums = {
  // GatlinBear Cub — minimum 4 bottles and $95.36
  "15270302548332": { 54280770814316: 95.36 },
  // GatlinBear Yearling — minimum 6 bottles and $134.25
  "15278754234732": { 54343851671916: 134.25 },
  // Gatlinbear Black Bear — minimum 12 bottles and $254.30
  "15278755348844": { 54343854260588: 254.30 }
};

/* Wines that every box must keep at quantity 1 or more.
   The merchant keeps the list in the store metafield
   custom.club_required_wines. snippets/awtomic-theme-custom.liquid puts that
   list in window.awtomicRequiredVariantIds. Add a variant id below ONLY to
   test the rule without the metafield, or if the metafield is not available.
   An empty list and an empty metafield apply no rule. */
const requiredWineIdsFallback = [];

/* Message shown in the box-builder footer while a required wine sits at
   quantity 0. */
const requiredWineNoteText = "Your box must include at least 1 bottle of each required wine.";

/* Note shown in the customer-portal delivery-method modal under the disabled
   "Pick up" option. */
const pickupNoteText = "Pickup is only available upon special request. Please contact us to arrange it.";

/* ===== END SHOP CONFIG — do not edit below this line ================ */

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

const formatMinimum = (amount) => Number(amount).toFixed(2);

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  // CP PRICE CHECK
  // In the portal box editor the widget wraps .bundle-container in the edit
  // wizard (.awt-bundle-update-wizard-step-edit-box), so the container is looked
  // up as a descendant of the modal, not as its direct child.
  waitForElement(".bundle-table__body-row--bab-parent", (element) => {
    const checkBabEdit = (bundleId, variantId) => {
      const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;

      const setAddToCartMinimumPrice = () => {
        const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen .bundle-container");

        if (!bundleContainer) return;

        const infoDiv = document.createElement("div");
        infoDiv.className = "minimum-price-info";
        infoDiv.innerText = `Minimum price of $${formatMinimum(minimumPrice)} is required for this club.`;

        const footerDiv = bundleContainer.querySelector("footer > div");
        if (footerDiv) {
          const lastDiv = footerDiv.querySelector("div:last-child");
          if (lastDiv) {
            footerDiv.insertBefore(infoDiv, lastDiv);
          }
        }

        const evaluate = () => {
          const priceSpan = document.querySelector("div > span.bundle-text--emphasis");
          const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
          if (!priceSpan || !addToCartButton) return;
          const innerPrice = parseFloat(priceSpan.innerText.replace(/[^0-9.,]/g, "").replace(",", ""));
          if (Number.isNaN(innerPrice)) return;
          const notMet = innerPrice < minimumPrice;
          addToCartButton.classList.toggle("priceNotMet", notMet);
          document.body.classList.toggle("priceNotMet", notMet);
        };

        // The widget re-renders the total AFTER the click event finishes, so a
        // click-time read is one step stale. Re-evaluate whenever the footer
        // changes, and once more shortly after any click as a fallback.
        const footer = bundleContainer.querySelector("footer");
        if (footer) {
          new MutationObserver(evaluate).observe(footer, { childList: true, subtree: true, characterData: true });
        }
        document.body.addEventListener("click", () => setTimeout(evaluate, 50));
        evaluate();
      };

      const checkIfPriceLabel = () =>
        document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

      let priceLabelSet = false;

      if (checkIfPriceLabel()) {
        setAddToCartMinimumPrice();
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (!priceLabelSet && mutation.addedNodes.length) {
              if (checkIfPriceLabel()) {
                setAddToCartMinimumPrice();
                priceLabelSet = true;
                observer.disconnect();
              }
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

        setTimeout(() => {
          observer.disconnect();
        }, 5000);
      }
    };

    Object.keys(babMinimums).forEach((bundleId) => {
      Object.keys(babMinimums[bundleId]).forEach((variantId) => {
        const selector = `tr[class*="${variantId}"]`;
        const element = document.querySelector(selector);
        if (element) element.addEventListener("click", () => checkBabEdit(bundleId, variantId));
      });
    });
  });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);

    if (babMinimums[bundleId]) {
      // Wait for footer to exist first, then set up the price checking
      waitForElement(".bundleapp-modal__container--complete-screen footer", () => {
        // Get variant ID from bundle container classes (e.g., div.bundle-container p_<productId> pv_<variantId>)
        const getVariantId = () => {
          const bundleContainer = document.querySelector(".bundle-container");
          if (!bundleContainer) return null;

          const classes = bundleContainer.className.split(" ");
          const variantClass = classes.find((c) => c.startsWith("pv_"));
          return variantClass ? variantClass.split("_")[1] : null;
        };

        let currentVariantId = getVariantId();

        const updatePriceChecking = (variantId) => {
          const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;

          const setAddToCartMinimumPrice = () => {
            const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen .bundle-container");

            if (!bundleContainer) return;

            // Remove existing minimum price info if any
            const existingInfo = bundleContainer.querySelector(".minimum-price-info");
            if (existingInfo) {
              existingInfo.remove();
            }

            const infoDiv = document.createElement("div");
            infoDiv.className = "minimum-price-info";
            infoDiv.innerText = `Minimum price of $${formatMinimum(minimumPrice)} is required for this club.`;

            const footerDiv = bundleContainer.querySelector("footer > div");
            if (footerDiv) {
              const lastDiv = footerDiv.querySelector("div:last-child");
              if (lastDiv) {
                footerDiv.insertBefore(infoDiv, lastDiv);
              }
            }

            const evaluate = () => {
              const priceSpan = document.querySelector("div > span.bundle-text--emphasis");
              const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
              if (!priceSpan || !addToCartButton) return;
              const innerPrice = parseFloat(priceSpan.innerText.replace(/[^0-9.,]/g, "").replace(",", ""));
              if (Number.isNaN(innerPrice)) return;
              const notMet = innerPrice < minimumPrice;
              addToCartButton.classList.toggle("priceNotMet", notMet);
              document.body.classList.toggle("priceNotMet", notMet);
            };

            // The widget re-renders the total AFTER the click event finishes, so a
            // click-time read is one step stale. Re-evaluate whenever the footer
            // changes, and once more shortly after any click as a fallback.
            const footer = bundleContainer.querySelector("footer");
            if (footer) {
              new MutationObserver(evaluate).observe(footer, { childList: true, subtree: true, characterData: true });
            }
            document.body.addEventListener("click", () => setTimeout(evaluate, 50));
            evaluate();
          };

          const checkIfPriceLabel = () =>
            document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

          let priceLabelSet = false;

          if (checkIfPriceLabel()) {
            setAddToCartMinimumPrice();
          } else {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (!priceLabelSet && mutation.addedNodes.length) {
                  if (checkIfPriceLabel()) {
                    setAddToCartMinimumPrice();
                    priceLabelSet = true;
                    observer.disconnect();
                  }
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });

            setTimeout(() => {
              observer.disconnect();
            }, 5000);
          }
        };

        // Initial setup if we have a variant ID
        if (currentVariantId) {
          updatePriceChecking(currentVariantId);
        }

        // Watch for variant changes in the bundle container
        const variantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
              const newVariantId = getVariantId();
              if (newVariantId && newVariantId !== currentVariantId) {
                currentVariantId = newVariantId;
                updatePriceChecking(currentVariantId);
              }
            }
          });
        });

        // Observe the bundle container for class changes
        const bundleContainer = document.querySelector(".bundle-container");
        if (bundleContainer) {
          variantObserver.observe(bundleContainer, {
            attributes: true,
            attributeFilter: ["class"]
          });
        }
      });
    }
  }
}

// BaB minimum gate, keyboard and scripted clicks: the CSS gate only stops the
// mouse (pointer-events), so Tab + Enter on "Add to cart" / "Save" still went
// through below the minimum. Block the click in the capture phase, before the
// widget sees it, while body.priceNotMet (price minimum) or
// body.awt-required-not-met (a required wine at quantity 0) is on.
if (window.location.pathname.includes("/tools/bundle-subscriptions")) {
  const blockBelowMinimum = (event) => {
    const bodyClasses = document.body.classList;
    if (!bodyClasses.contains("priceNotMet") && !bodyClasses.contains("awt-required-not-met")) return;
    const button = event.target.closest && event.target.closest(".bundleapp-modal__container--complete-screen footer button");
    if (!button) return;
    const buttons = button.closest("footer").querySelectorAll("button");
    if (button !== buttons[buttons.length - 1]) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  document.addEventListener("click", blockBelowMinimum, true);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") blockBelowMinimum(event);
  }, true);
}

//customer portal: the "Pick up" delivery method is admin-only
if (window.location.pathname.includes("/tools/bundle-subscriptions")) {
  const NOTE_CLASS = "awt-pickup-note";
  let scheduled = false;

  const disablePickupOption = () => {
    scheduled = false;
    const input = document.querySelector('.awt-shipping-address-modal input[type="radio"][value="pick-up"]');
    if (!input) return;

    if (!input.disabled) {
      input.disabled = true;
      input.setAttribute("aria-disabled", "true");
    }

    const radio = input.closest(".chakra-radio") || input.parentElement;
    const container = radio && radio.parentElement;
    if (container && !container.querySelector(`.${NOTE_CLASS}`)) {
      const note = document.createElement("p");
      note.className = NOTE_CLASS;
      note.textContent = pickupNoteText;
      radio.insertAdjacentElement("afterend", note);
    }
  };

  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(disablePickupOption);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  disablePickupOption();
}

/* ===== BUILD-A-BOX: REQUIRED WINES ===================================
   Each wine in the required list must stay at quantity 1 or more.
   - The rule applies to the club signup box builder and to the box editor in
     the customer portal. Both routes start with /tools/bundle-subscriptions.
   - At quantity 1 the minus button stops. The plus button continues to work.
   - While a required wine sits at quantity 0, the footer shows a message and
     the "Add to cart" / "Save" button stops.
   - A required wine that this club does not offer gets no rule, because the
     shopper cannot add it. */
(function () {
  if (window.location.pathname.indexOf("/tools/bundle-subscriptions") === -1) return;

  const source = (window.awtomicRequiredVariantIds || []).length
    ? window.awtomicRequiredVariantIds
    : requiredWineIdsFallback;

  const requiredIds = (source || [])
    .map(function (id) { return String(id).trim(); })
    .filter(function (id) { return id.length > 0; });

  if (!requiredIds.length) return;

  const NOT_MET_CLASS = "awt-required-not-met";
  const MIN_CLASS = "awt-required-min";
  const INFO_CLASS = "awt-required-info";
  const BUTTON_SELECTOR = ".bundle-product-card__quantity-button-container--button";

  const cardFor = function (id) {
    return (
      document.querySelector('.bundle-product-card[data-pid="' + id + '"]') ||
      document.querySelector(".bundle-product-card.p_" + id)
    );
  };

  const quantityOf = function (card) {
    const quantity = parseInt(card.getAttribute("data-quantity"), 10);
    return Number.isNaN(quantity) ? 0 : quantity;
  };

  const addInfoLine = function () {
    // descendant, not child: the portal box editor wraps .bundle-container
    const container = document.querySelector(".bundleapp-modal__container--complete-screen .bundle-container");
    if (!container || container.querySelector("." + INFO_CLASS)) return;

    const footerDiv = container.querySelector("footer > div");
    if (!footerDiv) return;

    const info = document.createElement("div");
    info.className = INFO_CLASS;
    info.innerText = requiredWineNoteText;

    const lastDiv = footerDiv.querySelector("div:last-child");
    if (lastDiv) footerDiv.insertBefore(info, lastDiv);
    else footerDiv.appendChild(info);
  };

  const evaluate = function () {
    if (!document.body.classList.contains("awt-bab-open")) {
      document.body.classList.remove(NOT_MET_CLASS);
      return;
    }

    let unmet = false;

    requiredIds.forEach(function (id) {
      const card = cardFor(id);
      if (!card) return;
      const quantity = quantityOf(card);
      card.classList.toggle(MIN_CLASS, quantity === 1);
      if (quantity < 1) unmet = true;
    });

    addInfoLine();
    document.body.classList.toggle(NOT_MET_CLASS, unmet);
  };

  /* pointer-events stops the mouse. A keyboard press on a button still sends a
     click, so the same check runs in the capture phase. */
  const blockDecrease = function (event) {
    const target = event.target;
    if (!target || !target.closest) return;

    const button = target.closest(BUTTON_SELECTOR);
    if (!button) return;

    const group = button.parentElement;
    if (!group || button !== group.querySelector(BUTTON_SELECTOR)) return;

    const card = button.closest(".bundle-product-card");
    if (!card || !card.classList.contains(MIN_CLASS)) return;

    event.preventDefault();
    event.stopPropagation();
  };

  document.addEventListener("click", blockDecrease, true);
  document.addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.key === " ") blockDecrease(event);
  }, true);

  /* The widget rewrites the card quantity after the click event finishes, so a
     click-time read is one step stale. Re-evaluate on every DOM change, and
     once more shortly after any click as a fallback. */
  let scheduled = false;
  const schedule = function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      evaluate();
    });
  };

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "data-quantity"]
  });

  document.body.addEventListener("click", function () { setTimeout(evaluate, 50); });
  evaluate();
})();
})();
